/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';
import type { ProposalSummaryIndividualDetails } from './ProposalSummaryIndividualDetails';
import {
    ProposalSummaryIndividualDetailsFromJSON,
    ProposalSummaryIndividualDetailsFromJSONTyped,
    ProposalSummaryIndividualDetailsToJSON,
} from './ProposalSummaryIndividualDetails';
import type { ProposalSummaryOrganisationDetails } from './ProposalSummaryOrganisationDetails';
import {
    ProposalSummaryOrganisationDetailsFromJSON,
    ProposalSummaryOrganisationDetailsFromJSONTyped,
    ProposalSummaryOrganisationDetailsToJSON,
} from './ProposalSummaryOrganisationDetails';

/**
 * 
 * @export
 * @interface ProposalSummaryClientDetails
 */
export interface ProposalSummaryClientDetails {
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof ProposalSummaryClientDetails
     */
    partyType: IAPPARTYTYPE;
    /**
     * 
     * @type {ProposalSummaryIndividualDetails}
     * @memberof ProposalSummaryClientDetails
     */
    individualDetails?: ProposalSummaryIndividualDetails;
    /**
     * 
     * @type {ProposalSummaryOrganisationDetails}
     * @memberof ProposalSummaryClientDetails
     */
    organisationDetails?: ProposalSummaryOrganisationDetails;
}

/**
 * Check if a given object implements the ProposalSummaryClientDetails interface.
 */
export function instanceOfProposalSummaryClientDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyType" in value;

    return isInstance;
}

export function ProposalSummaryClientDetailsFromJSON(json: any): ProposalSummaryClientDetails {
    return ProposalSummaryClientDetailsFromJSONTyped(json, false);
}

export function ProposalSummaryClientDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryClientDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyType': IAPPARTYTYPEFromJSON(json['PartyType']),
        'individualDetails': !exists(json, 'IndividualDetails') ? undefined : ProposalSummaryIndividualDetailsFromJSON(json['IndividualDetails']),
        'organisationDetails': !exists(json, 'OrganisationDetails') ? undefined : ProposalSummaryOrganisationDetailsFromJSON(json['OrganisationDetails']),
    };
}

export function ProposalSummaryClientDetailsToJSON(value?: ProposalSummaryClientDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyType': IAPPARTYTYPEToJSON(value.partyType),
        'IndividualDetails': ProposalSummaryIndividualDetailsToJSON(value.individualDetails),
        'OrganisationDetails': ProposalSummaryOrganisationDetailsToJSON(value.organisationDetails),
    };
}

